import React from 'react'
import Navbar from '../../component/navbar/container/Navbar'
import Footer from '../../component/footer/container/Footer'
import { Outlet } from "react-router-dom"
import { StyledLayout } from './Layout.style'

export default function Layout() {
    return (
        <StyledLayout >
            <div className='outlet'>
                <Navbar />
                <Outlet />
            </div>

            <Footer />
        </StyledLayout>
    )
}
